

import Utils from '../../app/utils';
import ExternalApiRequest from "services/externalApiRequest";

const { getUserInfoFromJwt } = Utils,
    userInfoConnnector = async () => {
        const userInfoformJwt = getUserInfoFromJwt();
        return {
            userInfoformJwt
        };
    };

const userDuesConnector = () => {
    const options = {
        api: "user-due-info"
    };
    return ExternalApiRequest(options).then(responseData => {
        return responseData;
    });
};

const userDataApiConnector = async (data) => {
    const options = {
        api: 'getUserData',
        content: {
            userId: data
        }
    };
    return await ExternalApiRequest(options);
};

export { userInfoConnnector, userDuesConnector, userDataApiConnector };
